import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { formatPenki, formatPenkiCompact } from '../utils/penki';
import './PenkiBadge.css';

interface PenkiBadgeProps {
  onClick?: () => void;
}

export const PenkiBadge: React.FC<PenkiBadgeProps> = ({ onClick }) => {
  const navigate = useNavigate();
  const { user } = useUser();
  const balance = user?.penki_balance ?? 0;

  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    navigate('/penki');
  };

  return (
    <button
      type="button"
      className="penki-badge"
      onClick={handleClick}
      aria-label={`Баланс: ${balance} УЙМ`}
    >
      <span className="penka-icon penka-icon--md" aria-hidden>
        <img src="/uym-mark.png" alt="" />
      </span>
      <span className="penki-badge-value">{formatPenki(balance)}</span>
    </button>
  );
};

interface PenkiChipProps {
  value: number;
  danger?: boolean;
  compact?: boolean;
  bare?: boolean;
  className?: string;
}

export const PenkiChip: React.FC<PenkiChipProps> = ({
  value,
  danger,
  compact,
  bare,
  className,
}) => {
  const classes = [
    'penki-chip',
    danger ? 'penki-chip--danger' : '',
    bare ? 'penki-chip--bare' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes}>
      <span className="penka-icon penka-icon--sm" aria-hidden>
        <img src="/uym-mark.png" alt="" />
      </span>
      {compact ? formatPenkiCompact(value) : formatPenki(value)}
    </span>
  );
};
